// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_form .confrimPass{margin-bottom:2px !important}.user_form .errorText{position:relative;transition:0.2s linear;min-height:19px}input::placeholder{color:#000;opacity:0.5}input[type=email]:not(.browser-default):-ms-input-placeholder{color:#c2c2c2}input[type=email]:not(.browser-default)::-ms-input-placeholder{color:#c2c2c2}[type=\"checkbox\"]:focus{box-shadow:0 0 0 3px #5694d6}\n", ""]);
// Exports
module.exports = exports;
